module.exports = __webpack_public_path__ + "img/markerTramRed.483430eb.svg";